import { cloneElement, useEffect, useRef, useState } from 'react';
import { ChevronDown, Search } from 'react-feather';
import { Button, Input } from 'antd';

import AntdFeatherIcon from '../AntdFeatherIcon';
import { HeaderToggleFiltersButton } from '../Buttons';

import './style.less';
import { Group } from '@/components/_common';

interface Props {
  onSearch?: (search: string) => void;
  searchValue?: string;
  extraFilters?: React.ReactElement;
  headerActions?:
    | React.ReactElement
    | ((options: { isShowingFilters: boolean }) => React.ReactNode);
  handleClickAdvancedFilters?: () => void;
  searchPlaceholder?: string;
  isOpen?: boolean;
}

const AppPageHeader: React.FC<Props> = ({
  onSearch,
  extraFilters,
  headerActions,
  searchValue,
  handleClickAdvancedFilters,
  searchPlaceholder = 'Pesquisar',
  isOpen = false,
}) => {
  const extraFiltersRef = useRef<HTMLDivElement>(null);

  const extraFiltersCloned = extraFilters
    ? cloneElement(extraFilters, { onMounted: applyHeight })
    : null;

  const [isShowingFilters, setIsShowingFilters] = useState(isOpen);
  const [filtersWrapperHeight, setFiltersWrapperHeight] = useState(0);

  const filtersWrapperClass = `filters-wrapper ${
    filtersWrapperHeight ? 'active' : ''
  }`;

  const getExtraFiltersHeight = () => {
    if (extraFiltersRef.current) {
      return extraFiltersRef.current.offsetHeight;
    }

    return 0;
  };

  useEffect(() => {
    if (!extraFilters) return;
    applyHeight();
  }, [isShowingFilters, window.innerWidth]);

  function applyHeight() {
    const newFiltersWrapperHeight = isShowingFilters
      ? getExtraFiltersHeight()
      : 0;

    setFiltersWrapperHeight(newFiltersWrapperHeight);
  }

  function renderHeaderAction() {
    if (typeof headerActions === 'function') {
      return headerActions({ isShowingFilters });
    }

    return !!headerActions && headerActions;
  }

  return (
    <div className="app-page-header">
      <div className="header-content">
        <div className="search-wrapper">
          {!!onSearch && (
            <Input
              value={searchValue}
              prefix={<Search />}
              className="search-filter-input"
              placeholder={searchPlaceholder}
              onChange={({ target: { value } }) => onSearch(value)}
            />
          )}

          {!!extraFilters && (
            <Group gap={!!handleClickAdvancedFilters ? 10 : 0}>
              <HeaderToggleFiltersButton
                className={isShowingFilters ? 'active' : ''}
                icon={<AntdFeatherIcon icon={<ChevronDown />} />}
                onClick={() => setIsShowingFilters(!isShowingFilters)}
              >
                Filtros
              </HeaderToggleFiltersButton>

              {!!handleClickAdvancedFilters && (
                <Button type="link" onClick={handleClickAdvancedFilters}>
                  Filtros Avançados
                </Button>
              )}
            </Group>
          )}
        </div>

        <div className="actions-wrapper">{renderHeaderAction()}</div>
      </div>

      <div
        className={filtersWrapperClass}
        style={{ height: filtersWrapperHeight }}
      >
        {!!extraFiltersCloned && (
          <div ref={extraFiltersRef}>
            {isShowingFilters ? extraFiltersCloned : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppPageHeader;
